import _ from 'lodash'
import { Box, Grid, Link, Skeleton, Typography } from '@mui/material'
import React from 'react'
import BodyHeader from '../molecules/BodyHeader'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'

import usePartner from '../../hooks/usePartner'
import usePartenaire from '../../hooks/usePartenaire'

const Partner = () => {
	const { isLoading, title, content } = usePartner()
	const { partenaires } = usePartenaire()

	return (
		<>
			{(isLoading && <Skeleton />) || <BodyHeader title={title}>{content}</BodyHeader>}

			{partenaires && (
				<>
					<Zone bgcolor="white">
						{_.keys(partenaires).map((categoryName, index) => (
							<Box key={index}>
								{categoryName && <TitleSubtitle subtitle={categoryName} />}
								<Grid container sx={{ my: 4 }}>
									<Grid
										item
										sx={{
											color: 'text.primary',
											textAlign: 'left',
											display: 'flex',
											flexFlow: 'row wrap',
											width: '100%',
										}}
									>
										{partenaires[categoryName].map(
											({ title, description, link }, partenaireIndex) => (
												<Typography
													component="div"
													key={`${index}${partenaireIndex}`}
													sx={{ flexBasis: '50%' }}
												>
													<Link href={link} underline="none" target="_blank" color="black">
														<Typography
															sx={{ fontSize: 18, fontWeight: 600 }}
															dangerouslySetInnerHTML={{ __html: title }}
														/>
														<Typography
															sx={{ fontSize: 18, fontWeight: 400, mb: 2 }}
															dangerouslySetInnerHTML={{ __html: description }}
														/>
													</Link>
												</Typography>
											),
										)}
									</Grid>
								</Grid>
							</Box>
						))}
					</Zone>
				</>
			)}
		</>
	)
}

export default Partner
